import { createContext, RefObject } from 'react';

type AppScreenContextState = {
  headerRef: RefObject<HTMLDivElement | null>;
};

export const AppScreenContext = createContext<AppScreenContextState | undefined>(undefined);
